<script>
  import { createEventDispatcher } from 'svelte'

  import dayjs from 'dayjs'
  import relativeTime from 'dayjs/plugin/relativeTime'
  dayjs.extend(relativeTime)

  import { focus } from '../misc.js'

  import authStore from '../auth/store.js'
  import approxNowStore from '../stores/approx-now.js'

  import dialogStore from './dialog/store.js'
  import toastStore from './toast/store.js'

  import AlertButton from './widgets/alert-button.svelte'
  import StarButton from './widgets/star-button.svelte'

  import PageSub from './page-sub.svelte'


  export let queueId

  let body
  let starred = false
  let alertDt = null

  $: unsaved = body && body.trim()

  const dispatch = createEventDispatcher()

  const back = function () {
    if (unsaved) {
      dialogStore.show('Unsaved Task',
                       'Are you sure you want to discard this unsaved task?',
                       [{name: 'Cancel', action: () => dialogStore.clear()},
                        {name: 'Discard', action: () => {
                          dispatch('back')
                          dialogStore.clear()
                        }}])
    } else {
      dispatch('back')
    }
  }

  const star = function () {
    starred = true
  }
  const unStar = function () {
    starred = false
  }

  const alert = function (event) {
    alertDt = event.detail.alertDt
  }
  const unAlert = function () {
    alertDt = null
  }

  const addTask = function () {
    const url = '/api/tasks?wait_for'
    const data = {
      version: 'v0',
      queue_id: queueId,
      body: body.trim(),
      starred,
      alert_dt: alertDt,
    }
    return authStore.request({method: 'post', url, data})
      .then(() => toastStore.success('Queued'))
      .catch(e => toastStore.error('Failed to queue task', e))
      .then(() => dispatch('added'))
  }

  const keyboardAddTask = function (event) {
    if (event.key === 'Enter' && event.ctrlKey) {
      addTask()
    }
  }
</script>

<PageSub title="Add Task" on:back={back}>
  {#if alertDt && dayjs(alertDt) > $approxNowStore}
    <div class="taskInfo">
      Alerts {dayjs(alertDt).from($approxNowStore)}
    </div>
  {/if}
  <form id="addTask" class="taskWrapper"
        on:submit|preventDefault={addTask}
        on:keydown={keyboardAddTask}>
    <textarea class="task"
              placeholder="What do you need to do?"
              bind:value={body} use:focus
              maxlength=10000 required pattern=".*\S.*"></textarea>
  </form>
  <div slot="controls" class="controls">
    <div class="toolbar">
      <StarButton {starred} on:star={star} on:unStar={unStar} />
      <AlertButton {alertDt} {unsaved} on:alert={alert} on:unAlert={unAlert} />
      <span class="spacer"></span>
      <button class="greyButton" type="submit" form="addTask">Add</button>
    </div>
  </div>
</PageSub>

<style>
  .taskInfo {
    padding: 0 20px 10px;

    font-size: 0.8em;
    font-weight: 400;
  }
</style>